var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "compare ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "compare-",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "compare-",
    transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25,8.25 L6.25,6.25 C6.25,5.84 6.59,5.5 7,5.5 C7.41,5.5 7.75,5.84 7.75,6.25 L7.75,8.25 C7.75,8.66 7.41,9 7,9 C6.59,9 6.25,8.66 6.25,8.25 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,8.25 L11.25,6.25 C11.25,5.84 11.59,5.5 12,5.5 C12.41,5.5 12.75,5.84 12.75,6.25 L12.75,8.25 C12.75,8.66 12.41,9 12,9 C11.59,9 11.25,8.66 11.25,8.25 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25,8.25 L16.25,6.25 C16.25,5.84 16.59,5.5 17,5.5 C17.41,5.5 17.75,5.84 17.75,6.25 L17.75,8.25 C17.75,8.66 17.41,9 17,9 C16.59,9 16.25,8.66 16.25,8.25 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,22.75 C3.57000017,22.75 1.25,20.4299998 1.25,15 L1.25,9 C1.25,3.57000017 3.57000017,1.25 9,1.25 L15,1.25 C20.4299998,1.25 22.75,3.57000017 22.75,9 L22.75,15 C22.75,20.4299998 20.4299998,22.75 15,22.75 L9,22.75 Z M2.75,9 L2.75,15 C2.75,19.6100001 4.38999987,21.25 9,21.25 L15,21.25 C19.6100001,21.25 21.25,19.6100001 21.25,15 L21.25,9 C21.25,4.38999987 19.6100001,2.75 15,2.75 L9,2.75 C4.38999987,2.75 2.75,4.38999987 2.75,9 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25,18 L6.25,16 C6.25,15.59 6.59,15.25 7,15.25 C7.41,15.25 7.75,15.59 7.75,16 L7.75,18 C7.75,18.41 7.41,18.75 7,18.75 C6.59,18.75 6.25,18.41 6.25,18 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,18 L11.25,16 C11.25,15.59 11.59,15.25 12,15.25 C12.41,15.25 12.75,15.59 12.75,16 L12.75,18 C12.75,18.41 12.41,18.75 12,18.75 C11.59,18.75 11.25,18.41 11.25,18 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25,18 L16.25,16 C16.25,15.59 16.59,15.25 17,15.25 C17.41,15.25 17.75,15.59 17.75,16 L17.75,18 C17.75,18.41 17.41,18.75 17,18.75 C16.59,18.75 16.25,18.41 16.25,18 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,12.75 C1.59,12.75 1.25,12.41 1.25,12 C1.25,11.59 1.59,11.25 2,11.25 L22,11.25 C22.41,11.25 22.75,11.59 22.75,12 C22.75,12.41 22.41,12.75 22,12.75 L2,12.75 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.8f0d9c176e41d2a1b6c907204ecc5194.svg";
export { ForwardRef as ReactComponent };